const secretKey = process.env.EN_KEY || 'reeCoTech2021Crypto'
const rowHeight = 150;
const columns = 6;

const defaultX = 0;
const defaultY = 0;
const defaultW = 1;
const defaultH = 1;
const defaultMinH = 1;
const PUBLIC_DASHBOARD_SESSION_KEY = 'pdss';
const TIMEOUT_SESSION = {
  amount: 2,
  unit: 'hour',
}
export {
  secretKey,
  rowHeight,
  columns,
  defaultX,
  defaultY,
  defaultW,
  defaultH,
  defaultMinH,
  PUBLIC_DASHBOARD_SESSION_KEY,
  TIMEOUT_SESSION
}